<template>
  <div class="error-page">
    <img src="../assets/logo.svg" alt="Varena Logo" class="error-logo" />
    <h1>{{ t('errors.403.title') }}</h1>
    <p>{{ t('errors.403.message') }}</p>
    <div class="actions">
      <el-button type="primary" @click="handleLogin">
        {{ t('errors.actions.login') }}
      </el-button>
      <el-button @click="router.back()">
        {{ t('errors.actions.goBack') }}
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const { t } = useI18n()
const router = useRouter()
const authStore = useAuthStore()

const handleLogin = () => {
  authStore.login()
}
</script>

<style scoped>
.error-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
  padding: 20px;
  background-color: #f5f7fa;
}

.error-logo {
  width: 200px;
  margin-bottom: 2rem;
  opacity: 0.8;
}

h1 {
  font-size: 3rem;
  color: #166b43;
  margin-bottom: 1rem;
}

p {
  font-size: 1.2rem;
  color: #606266;
  margin-bottom: 2rem;
}

.actions {
  display: flex;
  gap: 1rem;
}
</style> 